/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { Plugin } from 'ckeditor5';
import type { TrackChanges } from 'ckeditor5-premium-features';

export class TrackChangesIntegration extends Plugin {
	public static get requires() {
		return [ 'TrackChanges' ] as const;
	}

	public static get pluginName() {
		return 'TrackChangesIntegration' as const;
	}

	public init(): void {
		const trackChangesPlugin = this.editor.plugins.get( 'TrackChanges' ) as TrackChanges;

		const suggestionsData = [
			{
				id: 'suggestion-1',
				type: 'insertion',
				authorId: 'user-1',
				createdAt: new Date(),
				data: null,
				attributes: {}
			},
			{
				id: 'suggestion-2',
				type: 'deletion',
				authorId: 'user-1',
				createdAt: new Date(),
				data: null,
				attributes: {}
			}
		];

		for ( const suggestion of suggestionsData ) {
			trackChangesPlugin.addSuggestion( suggestion );
		}
	}
}
